import { ICommand, IDatasource, IDefineCommand, IQuery, IQueryMediator, key } from 'core-ts-types';
import * as _4 from 'lodash4';
import { APCourse } from '../builders/ap_course_builder';
import { APSectionType } from '../builders/ap_section_type_builder';
import { IAPCoursesDatasource } from '../datasources/ap_courses_datasource';
import { IAPSectionTypeDatasource } from '../datasources/ap_section_type_datasource';
import { APCourseServant } from '../servants/ap_course_servant';

interface IFavoriteCourseAPI {
  section_type: Record<string, APSectionType>;
  course: Record<string, APCourse>;
}

angular
  .module('capability-ng-academic-planner')
  .factory(
    'loadFavoriteCoursesCommand',
    (
      log: any,
      defineCommandORM: IDefineCommand,
      ngAPCoursesDatasource: IAPCoursesDatasource,
      ngAPSectionTypeDatasource: IAPSectionTypeDatasource,
      $http: ng.IHttpService
    ): ICommand => {
      return defineCommandORM(
        'loadFavoriteCoursesCommand',
        function loadFavoriteCoursesCommand(deferred: ng.IDeferred<IQuery[]>): void {
          $http
            .get('/reg/favoritecourse/')
            .then((response: { data: IFavoriteCourseAPI }) => {
              ngAPSectionTypeDatasource.write(response.data.section_type);

              // NAV-6300 Favorite UI caching issue
              // you login as a student with some favorite courses, goto favorite courses tab and logout.
              // Login as another student and goto favorites tab again, you will see the old favorites listed for the previous student there.
              // ngAPCoursesDatasource is being filled from several places, so we don't have flexibility to clear the whole data
              // before writing new. So clearing favorited entries because this is the only place it gets insterted to datasource
              ngAPCoursesDatasource.rewrite((db) =>
                _4.keyBy(
                  _4.filter(db, (course) => !course.is_favorite),
                  'id'
                )
              );

              ngAPCoursesDatasource.write(response.data.course);

              ngAPCoursesDatasource.cursor(response.data.course, (course) => {
                course.is_favorite = true;
                return course;
              });

              deferred.resolve();
            })
            .catch((e) => {
              log.issue('failed to load favorite courses');
              deferred.reject(e.data);
            });
        }
      );
    }
  );



// WEBPACK FOOTER //
// ./app/vendor/capability-ng-academic-planner/src/global/commands/load_favorite_courses_command.ts